import React from 'react';
import PropTypes from 'prop-types';

import InputField from './inputField';
import SelectField from './selectField';
import TypeaheadField from './typeaheadField';
import MultiCheckbox from './multiCheckbox';

const CustomField = ({
  field,
  errors,
  touched,
  errorIcon,
  setFieldValue,
  setFieldTouched
}) => {
  if (field.type === 'select')
    return (
      <SelectField
        label={field.label}
        errors={errors}
        touched={touched}
        name={field.name}
        id={field.id}
        defaultVal={field.defaultVal}
        list={field.list}
        allowOptionNull={field.allowOptionNull}
        errorIcon={errorIcon}
        val={field.val}
        readOnly={field.readOnly}
      />
    );
  if (field.type === 'multiCheckbox')
    return (
      <MultiCheckbox
        list={field.list}
        errors={errors}
        touched={touched}
        defaultVal={field.defaultVal}
        val={field.val}
        label={field.label}
        name={field.name}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
      />
    );
  if (field.type === 'typeahead')
    return (
      <TypeaheadField
        label={field.label}
        errors={errors}
        touched={touched}
        name={field.name}
        id={field.id}
        defaultVal={field.defaultVal}
        list={field.list}
        errorIcon={errorIcon}
        val={field.val}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
      />
    );
  return (
    <InputField
      label={field.label}
      errors={errors}
      touched={touched}
      name={field.name}
      placeholder={field.placeholder}
      readOnly={field.readOnly}
      type={field.type}
    />
  );
};

CustomField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    val: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    defaultVal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    list: PropTypes.array,
    allowOptionNull: PropTypes.bool
  }).isRequired,
  errors: PropTypes.objectOf(PropTypes.any),
  touched: PropTypes.objectOf(PropTypes.any),
  errorIcon: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired
};

CustomField.defaultProps = {
  errorIcon: '',
  errors: {},
  touched: {}
};

export default CustomField;
